/*!
 * Copyright (c) Trimble Inc. All rights reserved
 */

import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AddFittingPanelFrameComponent } from './add-fitting-panel-frame.component';
import { SelectSystemModule } from '../select-system';
import { SysqueContextMenuModule } from '../../../../../../shared/ui/src/lib/components/sysque-context-menu';
import { SelectCategoryModule } from '../select-category';
import { CategoryScopeModule } from '../category-scope';
import { DxContextMenuModule } from 'devextreme-angular';
import { ManageBtnModule } from '../manage-btn';
import { RootPathSelectorModule } from '../root-path-selector';

@NgModule({
  declarations: [AddFittingPanelFrameComponent],
  imports: [
    CommonModule,
    SelectSystemModule,
    SysqueContextMenuModule,
    SelectCategoryModule,
    CategoryScopeModule,
    DxContextMenuModule,
    ManageBtnModule,
    RootPathSelectorModule
  ],
  exports: [AddFittingPanelFrameComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class AddFittingPanelFrameModule {}
